module.exports = __webpack_public_path__ + "0af5d249/img/trash-icon.ff8201c7.svg";